module.exports = __webpack_public_path__ + "static/media/payslipMenuInactive.8b3d43cd.svg";